import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Banner from "../components/banner"
import ProvinceList from "../components/province-list"
import WeMakeProcessServingEasy from "../components/we-make-process-serving-easy"
import { Helmet } from "react-helmet"

export default function Template({ data, pageContext }) {

  const bannerUrl = "/home-banner.jpg";

  return ( 
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Prairie Process Serving</title>
      </Helmet>
      <Banner title="We serve with integrity, respect and results." imageUrl={bannerUrl}/>
      <section className="section process">
        <div className="container columns is-vcentered"> 
          <div className="column is-half content">
            <p>Founded in January 2021 by a paralegal with more than a decade of experience in the legal profession, Prairie Process Serving is a trusted Saskatchewan partner for law firms, financial instructions and out-of-province agencies requiring reliable process serving across Saskatchewan.</p>
            <p>Our reputation is built on proactive communication, court-ready Affidavits and a professional, compassionate approach to process serving.</p>
            <ProvinceList/>
          </div>
          <img className="column is-half" alt="Bright office with wooden clock on the wall." src="assets/about-01.jpg" />
        </div>
      </section>

      <section id="testimonials" className="section testimonials process">
        <div className="container"> 
          <h2>Testimonials</h2>
          <div className="container columns">
            <div className="column is-half content">
              <p><strong>Michael, a Manger for a National Legal Firm in Canada:</strong><br/>I have had the pleasure of working with 
              Prairie Process Serving Ltd. for all of our Saskatchewan legal-related matters for years now and 
              have never been disappointed. Kelly has always been fantastic to work with; she is professional, 
              reliable, highly responsive, and always ensures that the matters are handled efficiently and with 
              great attention to detail. We truly appreciate the excellent service and support provided by Kelly 
              and her team; we can always rely on them whenever needed. I highly recommend their services 
              to anyone needing dependable process serving.</p>
            </div>
            <div className="column is-half content">
            <p><strong>Leaha, Paralegal:</strong><br/>We have used the services of Prairie Process Serving for almost 3 years and 
            the level of service has always been top-notch. Not only do the process servers understand the 
            legal process involved in litigation matters, but they provide reliable and prompt service. They 
            are extremely professional and knowledgeable, and they have never let me down even when 
            service has been difficult. I always enjoy working with the process servers at Prairie Process 
            Serving as they make my job less stressful.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section steps">
        <WeMakeProcessServingEasy/>
      </section>
    </Layout>
  )
}
export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        slug
        title
      }
    }
  }
`